import React, { useState, useEffect} from "react";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
// import globalize from 'globalize'
// import events from './events/events'; 
import './calendar.css';
import { Container, Modal, Button, Form, Col, Row, Image, ButtonGroup, ToggleButton} from "react-bootstrap";
import { useForm } from "react-hook-form";
// import { useHistory } from "react-router-dom";
import axios from 'axios';
import SyncLoader from "react-spinners/SyncLoader";
import ParseBooking from '../../parse-booking';
import ParseSchedule from '../../parse-schedule';
import {main_services_list} from '../../lists/main-services-list';
import {recurrence_options} from '../../lists/recurrence-options';
import {hexColors} from '../../lists/hexColors';
import {five_min_list} from '../../lists/five-min-list';
import {FaCheck} from 'react-icons/fa';
import {FaSquare} from 'react-icons/fa';
import RefreshToken from '../../generic/refresh-token';
import DateForm from '../../functions/date-form'
import { RRule } from 'rrule'
import ReactGA from 'react-ga';

const eventStyleGetter = function (event, start, end, isSelected) {
    var backgroundColor = '#' + hexColors[event.title];
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: 'black',
        border: '0px',
        display: 'block'
    };
    return {
        style: style
    };
}

const localizer = momentLocalizer(moment)

export default function Calender(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const clinicData = props.location.state.clinicData;
    const backup_picture_url = "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"
    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            from: '00:00',
            to: '00:00'
        }
    });

    const token = localStorage.getItem('token');
    const axiosConfig = {
        headers: {
            Authorization: token
        }
    };

    const [loading, setLoading] = useState(false);
    const [schedule, setSchedule] = useState([]);
    const [dentists, setDentists] = useState([]);
    const [radioValue, setRadioValue] = useState(0);

    const [show, setShow] = useState(false);
    const [booking_id, setBooking_id] = useState('');

    const [showRemove, setShowRemove] = useState(false);
    const [showAddDentist, setShowAddDentist] = useState(false);
    const [reccuring, setReccuring] = useState(false);
    const [blockTime, setBlockTime] = useState(false);
    const [showRefreshToken, setShowRefreshToken] = useState(false);

    const [treatment, setTreatment] = useState('');
    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');
    const [bookingTime, setBookingTime] = useState('');

    const [tooEarlyTime, setTooEarlyTime] = useState(false);
    const [untilDate, setUntilDate] = useState('');

    const handleClose = () => setShow(false);
    const handleCloseRemove = () => setShowRemove(false);
    const handleCloseAddDentist = () => setShowAddDentist(false);
    const handleCloseTooEarlyTime = () => setTooEarlyTime(false);

    const handleBlockTime = () => setBlockTime(!blockTime);
    const handleReccuringOptions = () => setReccuring(!reccuring);

    const parse_Schedule = (idx, dents) => {
        let newSchedule = ParseSchedule(idx, dents); 
        setRadioValue(idx)
        setSchedule(newSchedule);
        setLoading(false);
        setDentists(dents)
    }


    useEffect(() => {
        const clinic_id = clinicData._id;
        axios.post("https://uae-dentist-backend.herokuapp.com/schedule/fetch-schedule", {clinic_id})
        .then((dentistsWithBookings) => {
            parse_Schedule(0, dentistsWithBookings.data.dentists)
        })
        .catch(function (error) {
            console.log(error);
        });
    }, [clinicData]);


    const handleSelect = (data) => {
        if(dentists.length === 0) {
            setShowAddDentist(true);
            return;
        }
        if(data.start < new Date()){
            setTooEarlyTime(true);
            return;
        }
        setShow(true)
        setStart(data.start);
        setEnd(data.end);
        const from = (data.start.getHours()<10?'0':'') + data.start.getHours() + ':' + (data.start.getMinutes()<10?'0':'') + data.start.getMinutes();
        const to = (data.end.getHours()<10?'0':'') + data.end.getHours() + ':' + (data.end.getMinutes()<10?'0':'') + data.end.getMinutes();
        let times = {from : from, to : to};
        reset(times)
        const firstMessage = clinicData.dentists[radioValue] && clinicData.dentists[radioValue].name + ', you are about to make ';
        const secondMessage = ' available for booking.';
        const time = ParseBooking(data, firstMessage, secondMessage)
        setBookingTime(time)
    }

    const onSelectEvent = (data) => {
        if(data.end < new Date()){
            setTooEarlyTime(true);
            return;
        }
        setShowRemove(true)
        setBooking_id(data.id);
        const time = ParseBooking(data)
        setTreatment(data.title)
        setBookingTime(time)
    }

    const removeTime = async () => {
        handleCloseRemove();
        setLoading(true);
        const dentist = dentists[radioValue];
        axios.post('https://uae-dentist-backend.herokuapp.com/schedule/remove-time', {_id : booking_id}, axiosConfig)
            .then(function(response){
                console.log(response)
                const index = dentist.schedule.findIndex(x => x._id === booking_id);
                console.log(index)
                console.log(dentist.schedule)
                dentist.schedule.splice(index, 1);
                console.log(dentist.schedule)
                parse_Schedule(radioValue, dentists)
                setLoading(false);
        })
        .catch(function (error) {
            if(error.statusCode === 401) {
                setShowRefreshToken(true)
            }
            setLoading(false);
        });
    }

    const onSubmit = async (data) => {
        handleClose();
        let value, label;
        if (blockTime) {
            label = 'Blocked'
            data.reserved = true;
            setBlockTime(!blockTime);
        } else {
            value = JSON.parse(data.services).value;
            label = JSON.parse(data.services).label;
        }

        let [startHours, startMinutes] = data.from.split(":");
        let [endHours, endMinutes] = data.to.split(":");
        setLoading(true);
        const dentist = dentists[radioValue];
        data.dentist_email          = dentist.email;
        data.dentist_id             = dentist._id;
        data.dentist_gender         = dentist.gender;
        data.dentist_name           = dentist.full_name;
        data.clinic_adress          = clinicData.address;
        data.clinic_id              = clinicData._id;
        data.clinic_image_urls      = clinicData.image_urls;
        data.clinic_name            = clinicData.clinic_name;
        data.price                  = clinicData.prices[value] || 0;
        data.title                  = label;
        data.emirate                = clinicData.emirate;
        data.start                  = new Date ( start.setHours (startHours, startMinutes) );
        data.end                    = new Date ( end.setHours(endHours, endMinutes) );

        if (reccuring) {
            setReccuring(!reccuring);
            var offset = new Date().getTimezoneOffset()/60;

            const dtstart = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate() - 1, startHours - offset + 1, startMinutes));
            const dtStartEnd = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate() - 1, endHours - offset + 1, endMinutes));
            const until = new Date (Date.UTC(untilDate.year, untilDate.month - 1, untilDate.day))

            let startTimeRule = new RRule({ dtstart, tzid: "Asia/Dubai", freq: RRule[data.recurrence], until})
            let endTimeRule = new RRule({ dtstart: dtStartEnd, tzid: "Asia/Dubai", freq: RRule[data.recurrence], until})

            data.startTimes = startTimeRule.all();
            data.endTimes = endTimeRule.all();

            axios.post('https://uae-dentist-backend.herokuapp.com/schedule/new-times', data, axiosConfig)
            .then(function(response){
                console.log(response.data.result);
                for (let i = 0; i< response.data.result.length; i++) {
                    let newTime = response.data.result[i];
                    let newBooking = {
                        end:    newTime.end,
                        start:  newTime.start,
                        title:  newTime.title,
                        _id:  newTime._id,
                    }
                    dentist.schedule.push(newBooking);
                    parse_Schedule(radioValue, dentists)
                }
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                if(error) {
                    setShowRefreshToken(true)
                }
            });
             
        } else {
            submitData(data);
        }

    }

    const submitData = async (data) => {
        const dentist = dentists[radioValue];
        axios.post('https://uae-dentist-backend.herokuapp.com/schedule/new-time', data, axiosConfig)
            .then(function(response){
                console.log(response);
                let newBooking = {
                    end:    data.end,
                    start:  data.start,
                    title:  data.title,
                    _id:  response.data._id,
                }
                dentist.schedule.push(newBooking);
                parse_Schedule(radioValue, dentists)
                setLoading(false);
        })
        .catch(function (error) {
            setLoading(false);
            if(error) {
                setShowRefreshToken(true)
            }
        });
    }

    return (

        <Container className='white' fluid>
        <RefreshToken show={showRefreshToken} setShow={setShowRefreshToken}/>
        <Row>
        <Col id='calender-dentist-list' className='bg-dark  p-0' sm={3} md={2} lg={2}>
            <ButtonGroup className='d-flex flex-column' toggle>
                {dentists.map((dentist, idx) => (
                        <ToggleButton 
                        key={dentist._id}
                        className='m-0 p-0'
                        value={idx}
                        type="radio"
                        variant="info"
                        name="radio" 
                        checked={radioValue === idx}
                        onChange={(e) => parse_Schedule(idx, dentists)}
                        >
                            { radioValue === idx && <FaCheck className='float-right green rounded m-2'/>}
                            <Image 
                            className='border mx-auto d-block mt-2' 
                            src={`${dentist.picture_url || backup_picture_url}`} 
                            width={64}
                            height={64}
                            roundedCircle />

                            <p style={{'fontSize':'15px'}}className="m-0">
                                {dentist.full_name} 
                            </p>
                            <p style={{'fontSize':'13px'}} className="">
                                {dentist.work_title}
                            </p>

                        </ToggleButton>
                ))}
            </ButtonGroup>
        </Col>

            <div className='mt-5'>
                <SyncLoader
                    size={15}
                    margin={2}
                    color={"#123abc"}
                    loading={loading}
                />
            </div>
            
            <Col className='my-2'>
            <Row>
                <Col>
                    <h6 className='my-2'><FaSquare style={{'color':'#ED7D31'}} className='mb-1' />: Emergency </h6>
                </Col>
                <Col>
                    <h6 className='my-2'><FaSquare style={{'color':'#A5A5A5'}} className='mb-1' />: Teeth Whitening </h6>
                </Col>
                <Col>
                    <h6 className='my-2'><FaSquare style={{'color':'#FFC000'}} className='mb-1' />: Dental Checkup</h6>
                </Col>
                <Col>
                    <h6 className='my-2'><FaSquare style={{'color':'#5B9BD5'}} className='mb-1' />: Teeth Cleaning</h6>
                </Col>
                <Col>
                    <h6 className='my-2'><FaSquare style={{'color':'#70AD47'}} className='mb-1' />: Online Dentist</h6>
                </Col>
                <Col>
                    <h6 className='my-2'><FaSquare style={{'color':'#000000'}} className='mb-1' />: Blocked</h6>
                </Col>
            </Row>


            {/* <div style={{ height: '100%', width: 'auto' }}> */}
            <Calendar
            selectable
            scrollToTime={new Date()}
            localizer={localizer}
            step={30}
            timeslots={2}
            events={schedule}
            defaultView='week'
            // startAccessor='start'
            // endAccessor="end"
            // view='week'
            eventPropGetter={(eventStyleGetter)}
            min={new Date(2020, 0, 1, 7, 0)} // 7.00 AM
            max={new Date(2020, 0, 1, 20, 0)} // Max will be 8.00 PM!
            views={['month', 'week', 'day']}
            defaultDate={new Date()}
            style={{ height: '80vh' }}
            onSelectSlot={handleSelect}
            onSelectEvent = {onSelectEvent} 
            />
            {/* </div> */}
        </Col>

        {/* //////////////////////////////////////////////////////////// */}
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add available time</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>Provider: {clinicData.dentists[radioValue] && clinicData.dentists[radioValue].full_name }</h5>
            <h5>Date: {start && start.getDate().toString()+'/'+(start.getMonth()+1).toString()+'/'+start.getFullYear().toString()} </h5>

            <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
                <Col>
                <Form.Group>
                    <Form.Label>From</Form.Label>
                    <Form.Control as="select"  name="from" ref={register ({required:true})} custom>
                        {five_min_list().map((five_min, idx) => (
                            <option key={idx}>{five_min}</option>
                        ))}
                    </Form.Control>
                </Form.Group>
                    {/* <Form.Group><Form.Label>From</Form.Label><Form.Control type='time' step="300" name="from" ref={register ({required:true})} placeholder={''} /></Form.Group> */}
                </Col>
                <Col>
                <Form.Group>
                <Form.Label>To</Form.Label>
                    <Form.Control as="select"  name="to" ref={register ({required:true})} custom>
                        {five_min_list().map((five_min, idx) => (
                            <option key={idx}>{five_min}</option>
                        ))}
                    </Form.Control>
                </Form.Group>
                    
                    {/* <Form.Group><Form.Label>To</Form.Label><Form.Control type='time' step="300" name="to" ref={register ({required:true})} placeholder={''} /></Form.Group> */}
                </Col>
            </Row>
            { !blockTime &&
            <Form.Group controlId="services">
            <Form.Label>Service</Form.Label>
            <Form.Control as="select"  name="services" ref={register ({required:true})} custom>
                {main_services_list.map((treatment, idx) => (
                    <option key={idx} value={JSON.stringify(treatment)}>{treatment.label}</option>
                ))}
            </Form.Control>
            </Form.Group>
            }
            <Row>
                <Col>
                    <Form.Group controlId="blockTime">
                        <Form.Check onClick={handleReccuringOptions} type="checkbox" ref={register} label="Recurring" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group controlId="reccuringOptions">
                        <Form.Check onClick={handleBlockTime} type="checkbox" ref={register} label="Block Time" />
                    </Form.Group>
                </Col>
            </Row>
            { reccuring &&
            <div>
            <Form.Group controlId="recurrence">
            <Form.Label>Recurrence</Form.Label>
                <Form.Control as="select"  name="recurrence" ref={register} custom>
                    {recurrence_options.map((option, idx) => (
                        <option key={idx} value={option.value}>{option.label}</option>
                    ))}
                </Form.Control>
            </Form.Group>
            <Form.Group controlId="until">
                <p className='mb-1'>Until</p>
                <DateForm startDate={start} setDate={setUntilDate}/>
            </Form.Group>
            </div>
            }
            <Button variant="primary" type="submit">
                Add
            </Button>
            </Form>
          </Modal.Body>
        </Modal>

        {/* //////////////////////////////////////////////////////////// */}

        <Modal show={showRemove} onHide={handleCloseRemove}>
          <Modal.Header closeButton>
            <Modal.Title>Do you want to remove this time?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{treatment} at {bookingTime}.</p>
            <Button onClick={removeTime} variant="primary" type="submit">
                Remove
            </Button>
          </Modal.Body>
        </Modal>

        {/* //////////////////////////////////////////////////////////// */}

        <Modal show={showAddDentist} onHide={handleCloseAddDentist}>
          <Modal.Header closeButton>
            <Modal.Title>Please add a dentist.</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Please add a dentist before starting to add available times.</p>
            <Button onClick={handleCloseAddDentist} variant="primary" type="submit">
                Close
            </Button>
          </Modal.Body>
        </Modal>

        <Modal show={tooEarlyTime} onHide={handleCloseTooEarlyTime}>
          <Modal.Header closeButton>
            <Modal.Title>This time has already passed</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Please select a time that's not in the past.</p>
            <Button onClick={handleCloseTooEarlyTime} variant="primary" type="submit">
                Close
            </Button>
          </Modal.Body>
        </Modal>

        </Row>
        </Container>
    )

}